import { Link } from "react-router-dom";
import { PawPrint, Heart } from "lucide-react";
import Newsletter from "./Newsletter";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="mt-24 border-t border-kblborder bg-white"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <div className="flex items-center gap-2 mb-4">
                        <span className="w-9 h-9 rounded-2xl bg-kblyellow flex items-center justify-center">
                            <PawPrint className="w-5 h-5" strokeWidth={2.4} />
                        </span>
                        <span className="font-display font-black text-2xl">
                            Kiblco
                        </span>
                    </div>
                    <p className="text-kblmuted text-base max-w-sm leading-relaxed">
                        Honest, hand-tested reviews of trending dog and cat
                        products — written by pet parents, for pet parents.
                    </p>
                    <p className="mt-6 text-xs uppercase tracking-[0.18em] font-semibold text-kblmuted">
                        Smarter picks for happier pets.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <h4 className="font-display font-bold text-base mb-4">
                        Explore
                    </h4>
                    <ul className="space-y-2 text-sm text-kblmuted">
                        <li>
                            <Link
                                to="/blog"
                                className="hover:text-kblink"
                                data-testid="footer-blog"
                            >
                                All reviews
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/category/dog-health"
                                className="hover:text-kblink"
                            >
                                Dog health
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/category/cat-litter"
                                className="hover:text-kblink"
                            >
                                Cat litter
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/category/pet-tech"
                                className="hover:text-kblink"
                            >
                                Pet tech
                            </Link>
                        </li>
                        <li>
                            <Link to="/about" className="hover:text-kblink">
                                About Kiblco
                            </Link>
                        </li>
                        <li>
                            <Link to="/privacy" className="hover:text-kblink" data-testid="footer-privacy">
                                Privacy policy
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <h4 className="font-display font-bold text-base mb-4">
                        New picks in your inbox
                    </h4>
                    <Newsletter compact source="footer" />
                </div>
            </div>

            <div className="border-t border-kblborder">
                <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-kblmuted">
                    <p>
                        © {new Date().getFullYear()} Kiblco. Affiliate
                        disclosure: we may earn a commission on links.
                    </p>
                    <p className="flex items-center gap-1.5">
                        Made with{" "}
                        <Heart className="w-3.5 h-3.5 fill-kblcoral text-kblcoral" />{" "}
                        for dogs & cats.
                    </p>
                </div>
            </div>
        </footer>
    );
}
